/** Shared timestamp formatter for domain template views (en-GB 24h, dd/mm/yyyy hh:mm:ss). */
export function fmtTs(v?: number): string {
  if (!v) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }).format(new Date(v));
}
